<template>
  <div
    class="reasons reasons1 reasons--1 lp-section width-expand padding-2xl-vertical l:padding-max-vertical"
    :class="`bg-${backgroundColor}`"
    :id="`Reasons1-${pageUid}`">
    <div class="container margin-auto-inline">
      <div class="title-block flex flex-center width-expand">
        <h2 class="text-3xl l:text-max" :class="`c-${titleColor}`">
          <span class="bold">{{ title }}</span>
          <span class="bold" v-if="isNonEmptyString(liveLogoText)">מיטב</span>
          <span
            class="bold"
            v-if="isNonEmptyString(liveLogoText)"
            :class="`c-${logoSeparatorColor}`"
            style=""
            >:</span
          ><span>{{ liveLogoText }}</span>
        </h2>
      </div>

      <div class="reason-groups">
        <div
          class="reason-group"
          v-for="group of groups">
          <div class="reason-title-block flex gap-l flex-middle">
            <div
              class="image-block square width-80 background-cover"
              :style="`background-image: url('${group.image}');flex:0 0 80px;`"></div>

            <div
              class="h4 text text-2xl margin-remove bold"
              :class="`c-${itemTitleColor}`">
              {{ group.title }}
            </div>
          </div>
          <div class="reason-item-block margin-xl-top">
            <ul class="unstyled-list">
              <li
                v-for="item in group.items"
                class="margin-l-bottom flex flex-middle flex-start gap-m">
                <div
                  class="circle border-radius-round"
                  style="flex: 0 0 10px; height: 10px; width: 10px"
                  :class="`bg-${itemBulletsColor}`"></div>
                <span
                  :class="`c-${itemTextColor}`"
                  class="item-text line-height-090"
                  >{{ item.text }}</span
                >
              </li>
            </ul>
            <form-button v-if="group?.groupButton?.text"
                         class="margin-xl-top"
                         @click="group.groupButton.navigationHandler"
                         v-bind="group.groupButton"></form-button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import useUiElements from "@/client/extensions/composition/useUiElements";
import lpSectionMixin from "@/client/applications/meitavlp/extensions/mixins/lpSection";
import { inject } from "vue";

export default {
  mixins: [lpSectionMixin],
  setup(props) {
    let pageUid = inject("pageUid");

    let schema = {
      title: "",
      liveLogoText: "",
      groups: {
        image: "",
        title: "",
        items: {
          text: "",
        },
        button: "",
      },
      backgroundColor: "",
      titleColor: "",
      logoSeparatorColor: "",
      itemTitleColor: "",
      itemTextColor: "",
      itemBulletsColor: "",
    };
    let {wrapUiElement } = useUiElements({});
    let overloadedProps = useUiElements({ input: props.sectionData }).props;

    try {
      overloadedProps.groups.forEach(group => {
        if (utilities.isObject(group.groupButton)) {
          group.groupButton = wrapUiElement(group.groupButton);
        }
      });
    } catch(e) {
      console.log(e);
    }

    console.log('reasons setup', inject("track"));
    return {
      ...schema,
      ...overloadedProps,
      allData: overloadedProps,
      pageUid,
      trackEvent: inject("trackEvent"),
      track: inject("track"),
      triggerSectionsEvent: inject("triggerSectionsEvent"),
    };
  },
  data: function () {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style scoped lang="scss">
.reasons1 {
  .title-block {
    margin-bottom: calc(var(--margin-max) * 0.7);

    @media (max-width: 1024px) {
      margin-bottom: calc(var(--margin-max) * 0.6);
    }
  }

  .reason-groups{
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
    gap: var(--margin-xl);
    row-gap: var(--margin-max);

    @media (max-width: 1024px) {
      flex-direction: column;
      align-items: center;
      gap: var(--margin-xl);
      row-gap: var(--margin-xl)

    }
  }
  .reason-group {
    @media (min-width: 1024px) {
      flex: 0 1 400px;
      width: 400px;
      max-width: 100%;
      padding-inline-start: 94px;
    }

    flex: auto;
    width: 400px;
    max-width: 100%;

    .reason-title-block {
      position: relative;

      .image-block {
        width: 80px;
        height: 80px;
        flex: 0 0 80px;

        @media (min-width: 1024px) {
          position: absolute;
          inset-inline-start: -94px;
        }
      }
    }

    .item-text {
      font-size: calc(var(--font-xl) * 0.92);
    }
  }
}
</style>
